module.exports = __webpack_public_path__ + "static/media/socioterapia.b2a8959a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/exhibitors/socioterapia.jpeg
// module id = 459
// module chunks = 0